import { Injectable } from '@angular/core';
import { Select3dService } from './select-3d.service';
import { ConstantsService } from './constants.service';
import { WallCutService } from './wall/wall-cut.service';
import { HttpClient } from '@angular/common/http';

declare const THREE: any;

interface IMaterial {
  thumbnail: string;
  texture: string;
}

interface IWallMaterials {
  [groupName: string]: Array<IMaterial>;
}

@Injectable()
export class SetWallMaterialService {
  private textureUrl = `../../assets/images/texture/wall/`;

  currentSection = '';
  private currentTextureToSprite = '';
  private currentTextureUrl = '';

  private selectedWall = null;
  private materials: IWallMaterials;

  constructor(
    private select3DSrvc: Select3dService,
    private constantsService: ConstantsService,
    private wallCutSrvc: WallCutService,
    private http: HttpClient
  ) {
    this.select3DSrvc.selectedWallSubject.subscribe(value => {
      this.setSelectedWall(value);
    });
    this.loadMaterials();
  }

  private async loadMaterials() {
    this.materials = await this.http
      .get<IWallMaterials>('../../assets/images/texture/wall/data.json')
      .toPromise();
  }

  setSection(section) {
    this.currentSection = section;
  }

  setCurrentTexture(index) {
    this.currentTextureToSprite = this.materials[this.currentSection][index].thumbnail;
    this.currentTextureUrl = this.materials[this.currentSection][index].texture;
  }

  getCurrentTextureToSprite() {
    return this.currentTextureToSprite;
  }

  getCurrentTextureUrl() {
    return this.currentTextureUrl;
  }

  getSpritesBySection(section) {
    return this.materials[section].map(m => m.thumbnail);
  }

  getSelectedWall() {
    return this.selectedWall;
  }

  setSelectedWall(wall: any): void {
    this.selectedWall = wall;
  }

  changeSelectedWallMaterial(textureUrl?: string, wall?: any): any {
    let textureToApply = this.currentTextureUrl;
    if (textureUrl && textureUrl.includes(this.textureUrl)) {
      textureToApply = textureUrl;
    }
    new THREE.TextureLoader().load(textureToApply, texture => {
      const currentWall = wall || this.selectedWall;
      const wallHeight = currentWall.userData.config.height,
        wallLength = currentWall.userData.config.width,
        wallDepth = this.constantsService.wallDepth;

      const pixelsInCm = 5;
      const imageHeight = texture.image.height;
      const pixelsInCurrentWallHeight = wallHeight * pixelsInCm;
      const repeatY = pixelsInCurrentWallHeight / imageHeight;
      const imageWidth = texture.image.width;
      const pixelsInCurrentWallLength = wallLength * pixelsInCm;
      const repeatX = pixelsInCurrentWallLength / imageWidth;
      const pixelsInCurrentWallDepth = wallDepth * pixelsInCm;
      const repeatZ = pixelsInCurrentWallDepth / imageWidth;

      texture.wrapS = texture.wrapT = THREE.RepeatWrapping;
      texture.repeat.set(repeatX, repeatY);

      const topTexture = texture.clone();
      topTexture.needsUpdate = true;
      topTexture.wrapS = topTexture.wrapT = THREE.RepeatWrapping;
      topTexture.repeat.set(repeatX, repeatZ);

      const sideTexture = texture.clone();
      sideTexture.needsUpdate = true;
      sideTexture.wrapS = sideTexture.wrapT = THREE.RepeatWrapping;
      sideTexture.repeat.set(repeatZ, repeatY);

      const materials = [
        new THREE.MeshPhongMaterial({ map: sideTexture }), // right
        new THREE.MeshPhongMaterial({ map: sideTexture }), // left
        new THREE.MeshPhongMaterial({ map: topTexture }), // top
        new THREE.MeshPhongMaterial({ map: topTexture }), // bottom
        new THREE.MeshPhongMaterial({ map: texture }), // face
        new THREE.MeshPhongMaterial({ map: texture }) // back
      ];

      currentWall.material = materials;
      currentWall.userData.config.firstPoint.material = textureToApply;
      currentWall.userData.config.material = textureToApply;
      this.wallCutSrvc.cutHoles(currentWall);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/set-wall-material.service.ts